import { a } from './chunk-IMSWER4T.js';

var e=class{async getFeaturesJson(i){try{let t=a.instance;if(t.config.isAuthenticated)return (await t.get(i)).data.data}catch{return}}};

export { e as a };
//# sourceMappingURL=chunk-TISKHNE7.js.map
//# sourceMappingURL=chunk-TISKHNE7.js.map